/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Group_FitnessInputs */

const en_service_type_group_fitness = /** @type {(inputs: Service_Type_Group_FitnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group fitness classes`)
};

const pl_service_type_group_fitness = /** @type {(inputs: Service_Type_Group_FitnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zajęcia fitness`)
};

/**
* | output |
* | --- |
* | "Group fitness classes" |
*
* @param {Service_Type_Group_FitnessInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_group_fitness = /** @type {((inputs?: Service_Type_Group_FitnessInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Group_FitnessInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_group_fitness(inputs)
	return en_service_type_group_fitness(inputs)
});